<template>
  <Teleport to="body">
    <div
      class="h5-page-dialog"
      v-if="show"
    >
      <div
        class="h5-page-dialog__header"
      >
        <slot name="header">
          {{ title }}
        </slot>
        <Icon
          class="h5-page-dialog__close"
          name="icon-arrow-left-l"
          @click="show = false"
        />
      </div>
    </div>
    <Transition
      name="h5-page-dialog-transition"
    >
      <div
        v-if="show"
        class="h5-page-dialog__content"
      >
        <slot />
      </div>
    </Transition>
  </Teleport>
</template>

<script setup>
import { Icon } from '@/components/Icon'

defineProps({
  title: {
    type: String,
    required: true
  }
})
const show = defineModel('show', { type: Boolean })

</script>

<style lang="less">
.h5-page-dialog {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1101;

  &__header {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 12px;
    padding: 12px;
    height: 48px;
    border-radius: 8px;
    font-family: mon-700;
    font-size: 14px;
    line-height: 18px;
    background-color: #FFFFFF;
  }

  &__close {
    position: absolute;
    top: 12px;
    left: 12px;
    font-size: 24px;
  }

  &__content {
    z-index: 1110;
    position: fixed;
    left: 12px;
    bottom: 12px;
    right: 12px;
    background-color: white;
    height: calc(100% - 84px);
    transition: height 0.3s ease-in-out;
    border-radius: 8px;
    overflow: hidden;
  }
}

.h5-page-dialog-transition-enter-from,
.h5-page-dialog-transition-leave-to {
  height: 0;
}
.h5-page-dialog-transition-enter-to,
.h5-page-dialog-transition-leave-from {
  height: calc(100% - 84px);
}
</style>
